module.exports = __webpack_public_path__ + "bar-icon.36814c748978e0b31ecf.png";


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/Techbotz-master/src/assets/images/bar-icon.png
// module id = ../../../../../src/assets/images/bar-icon.png
// module chunks = styles